import { history } from 'ice';
import React from 'react';
import styles from './MobileHomeHotMessage.module.scss';
import moment from 'moment';
const MobileHomeHotMessage = (props) => {
  return (
    <>
      <div
        className={styles.item}
        onClick={() => {
          history.push('/mobile/announcement/announcementFrontDesk');
        }}
      >
        <div className={styles.t1}>
          <span>{props.type}</span>
        </div>
        <div className={styles.t2}>
          <p className={styles.title}>{props.title}</p>
          <p className={styles.time}>
            {moment(props.createdTime).format('YYYY-MM-DD')}
          </p>
        </div>
        <div className={styles.t3}>{props.content}</div>
      </div>
    </>
  );
};

export default MobileHomeHotMessage;
